import $ from 'jquery';
// $('.ma_link').click(function(e) {
// 	var lf_scroll = $(".kf__slides").width() ;
// 	let kf_width = $(".kf__slide-1").width();
// 	console.log(lf_scroll); 
// 	console.log('dupa');
// 	console.log(kf_width); 
// 	// doSomething();

// 	var full = lf_scroll * 5 ;
// 	var scrollWidth = $(".kf__slides").prop("scrollWidth") ;
// 	let a_nr = $(this).data('nr');
// 	let scroll_position = scrollWidth / ( 5 - a_nr);
// 	console.log(a_nr)
// 	console.log(scroll_position)
// 	console.log(scrollWidth)
// 	$(".kf__slides").scrollLeft(scroll_position);
// 	// return false;
// });
var $swiperSelector = $('.swiper-container');

$swiperSelector.each(function(index) {
    var $this = $(this);
    $this.addClass('swiper-slider-' + index);
    
    var dragSize = $this.data('drag-size') ? $this.data('drag-size') : 50;
    var freeMode = $this.data('free-mode') ? $this.data('free-mode') : true;
    var loop = $this.data('loop') ? $this.data('loop') : false;
    var slidesDesktop = $this.data('slides-desktop') ? $this.data('slides-desktop') : 1;
    var slidesTablet = $this.data('slides-tablet') ? $this.data('slides-tablet') : 1;
    var slidesMobile = $this.data('slides-mobile') ? $this.data('slides-mobile') : 1;
    var spaceBetween = $this.data('space-between') ? $this.data('space-between'):80;

    var swiper = new Swiper('.swiper-slider-' + index, {
      direction: 'horizontal',
      loop: loop,
      freeMode: freeMode,
      spaceBetween: spaceBetween,
      breakpoints: {
        1920: {
          slidesPerView: slidesDesktop
        },
        992: {
          slidesPerView: slidesTablet
        },
        320: {
           slidesPerView: slidesMobile
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: dragSize
      }
   });
});



$('.swiper-button-next,.swiper-button-prev').on('click tap', function(){
    
    $("iframe").each(function() { 
        var src= $(this).attr('src');
        $(this).attr('src',src);  
    });
});